// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-nav-group{
  padding-left:0;
}

.side-nav-item-group{
  padding-bottom:1rem;
  border-bottom:0.0625rem solid #d4d4d4;
}

:host:last-child > .side-nav-item-group{
  border-bottom:0;
}

.side-nav-item{
  padding:1rem 1rem 0 1rem;
  margin:0;
}

.side-nav-item__label,
  .side-nav-item__link,
  .side-nav-item__button{
    position:relative;
    display:flex;
    align-items:center;
    font-weight:400;
    color:#424242;
    -webkit-user-select:none;
            user-select:none;
  }

.side-nav-item__link,
  .side-nav-item__button{
    -webkit-text-decoration:none;
    text-decoration:none;
    cursor:pointer;
    transition:border-bottom-color 500ms;
  }

.side-nav-item__link:hover,
    .side-nav-item__link:focus,
    .side-nav-item__button:hover,
    .side-nav-item__button:focus{
      color:#00429d;
      border-bottom-color:#00429d;
    }

.side-nav-item__link:hover .side-nav-item__icon, .side-nav-item__link:focus .side-nav-item__icon, .side-nav-item__button:hover .side-nav-item__icon, .side-nav-item__button:focus .side-nav-item__icon{
        color:#00429d;
      }

.side-nav-item__button{
    width:100%;
    height:100%;
    padding:0;
    background:none;
    border:none;
  }

.side-nav-item__icon{
    color:#206dd2;
  }

.side-nav-item--active > a{
      color:#206dd2;
    }

.side-nav-item--active > a:hover{
        color:#00429d;
      }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
